import { useEffect } from 'react';

import { selectReferenceBarUI } from '../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import {
  ALERT_TOAST_DATA_ATTR,
  ALERT_TOAST_PROPERTY_ID_ATTR,
  COMPARABLES_ALERTS_TOAST_CLASS_NAME,
} from './useToaster/constants.ts';
import './useToaster/comparablesToast.scss';

const HOVER_SYNCED_CLASS_NAME = 'comparables-alerts-toast--hover-synced';

export const useAlertToastHoverEmphasis = () => {
  const { hoveredAlertType, hoveredAlertPropertyID } = useAppSelector(selectReferenceBarUI);

  useEffect(() => {
    const toasterRoot = document.getElementById('_rht_toaster');
    if (!toasterRoot) {
      return;
    }

    toasterRoot.querySelectorAll(`.${COMPARABLES_ALERTS_TOAST_CLASS_NAME}`).forEach((toastEl) => {
      const toastContent = toastEl.querySelector(`[${ALERT_TOAST_DATA_ATTR}]`);
      const alertType = toastContent?.getAttribute(ALERT_TOAST_DATA_ATTR);
      const alertPropertyID = toastContent?.getAttribute(ALERT_TOAST_PROPERTY_ID_ATTR) ?? null;
      const isHovered =
        alertType === hoveredAlertType &&
        hoveredAlertPropertyID === alertPropertyID;
      toastEl.classList.toggle(HOVER_SYNCED_CLASS_NAME, isHovered);
    });
  }, [hoveredAlertType, hoveredAlertPropertyID]);
};
